export default "__VITE_ASSET__a9c0ffec__"